export const generateServices = (map) => (request) => {
  const { serviceId, service } = request;
  const id = serviceId || 0;

  const entity = map.get(id) || {
    name: service || 'Не указано',
    amount: 0,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};
